import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useLanguage } from "@/context/LanguageContext";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  const { t } = useLanguage();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-background px-4 text-center">
      <Logo />
      <div>
        <p className="font-display text-6xl font-extrabold text-slate-900">404</p>
        <p className="mt-2 text-slate-500">{t("not_found")}</p>
      </div>
      <Button asChild className="rounded-full min-h-[44px]">
        <Link to="/" data-testid="notfound-home-btn">{t("go_home")}</Link>
      </Button>
    </div>
  );
}
